import styled from '@emotion/styled';
import { colors } from 'Constants/Colors';

export const CustomSelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

// `span` y no `label`: el control de MUI es un `role="button"`, que no es
// etiquetable, así que un `label` quedaría huérfano y su clic no enfocaría
// nada. El nombre accesible viaja por `aria-labelledby`.
export const CustomSelectLabel = styled.span`
  display: block;
  font-size: 0.875rem;
  color: ${colors.GRAY_DARK};
  visibility: ${({ hidden }) => (hidden ? 'hidden' : 'visible')};
`;
